import { ModalBody, ModalHeader } from 'reactstrap'
import { useSelector } from 'react-redux'

import _ from 'lodash'
import styled from 'styled-components'
import { Modal } from 'common-components/index'

const DivText = styled.div`
  margin-bottom: 0px;
  display: block;
  text-align: center;
  @media screen and (max-width: 650px) {
    display: inline;
  }
`

// Mobile-only variant used in the dialog
const DivMobile = styled.p`
  margin-bottom: 0px;
  display: block;
  @media screen and (max-width: 650px) {
    display: inline;
  }
`

const EkycRevalidateAge = () => {
  const state = useSelector((state) => state)
  const isLoading = _.get(state, ['ui', 'isModalLoading'], false)

  return (
    <Modal className={''} isOpen={isLoading} size="md" modalClassName="default-bootstrap remote-selling-modal">
      <ModalHeader className={'header-modal'} style={{ display: 'flex', justifyContent: 'center' }}>
        ระบบกำลังประมวลผลข้อมูล
      </ModalHeader>
      <ModalBody>
        <div
          className={'flex-container'}
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            alignContent: 'center',
            alignItems: 'center',
            marginTop: '60px',
            marginBottom: '110px',
          }}
        >
          <DivText style={{ marginBottom: '0px' }}>
            ขณะนี้ระบบกำลังดำเนินการตรวจสอบผลการยืนยันตัวตน{' '}
            <DivMobile style={{ marginBottom: '0px' }}>โปรดรอสักครู่ เพื่อความถูกต้องของข้อมูล</DivMobile>
          </DivText>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default EkycRevalidateAge
